export default __webpack_public_path__ + "static/media/login-partner-bg.7d321a96.jpg";